/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Many_Wallaby_LockInputs */

const fr_witty_many_wallaby_lock = /** @type {(inputs: Witty_Many_Wallaby_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max (min:sec)`)
};

/**

* @param {Witty_Many_Wallaby_LockInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_many_wallaby_lock = /** @type {((inputs?: Witty_Many_Wallaby_LockInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Many_Wallaby_LockInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_many_wallaby_lock(inputs)
});